import { render, staticRenderFns } from "./CalendarNavigation.vue?vue&type=template&id=488dd54e&scoped=true&"
import script from "./CalendarNavigation.vue?vue&type=script&lang=js&"
export * from "./CalendarNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CalendarNavigation.vue?vue&type=style&index=0&id=488dd54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dd54e",
  null
  
)

export default component.exports